import React from "react";
import {
  Box,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import SectionCard from "./SectionCard";

const Step2BusinessDetails = ({
  formData,
  onFieldChange,
  errors,
  touched,
  setFieldValue,
}) => {
  const fieldError = (name) => Boolean(touched?.[name] && errors?.[name]);
  const fieldHelper = (name) => (touched?.[name] && errors?.[name]) || "";
  const showTurnover = formData.turnoverApplicable === "Y";

  const handleTurnoverApplicableChange = (e) => {
    const value = e.target.value;
    setFieldValue("turnoverApplicable", value);
    if (value === "N") {
      [1, 2, 3].forEach((i) => {
        setFieldValue(`turnoverYear${i}`, "");
        setFieldValue(`turnoverRevenue${i}`, "");
      });
    }
  };

  return (
    <Box>
      <SectionCard title="TURNOVER">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl component="fieldset" error={fieldError("turnoverApplicable")}>
              <RadioGroup
                row
                name="turnoverApplicable"
                value={formData.turnoverApplicable || ""}
                onChange={handleTurnoverApplicableChange}
              >
                <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                <FormControlLabel value="N" control={<Radio />} label="No" />
              </RadioGroup>
              {fieldError("turnoverApplicable") && (
                <FormHelperText>{fieldHelper("turnoverApplicable")}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </SectionCard>

      {showTurnover && (
        <SectionCard title="TURNOVER (INR Cr.) (Last 3 yrs)">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Year</TableCell>
                      <TableCell>Revenue (INR Cr.)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[1, 2, 3].map((i) => (
                      <TableRow key={i}>
                        <TableCell>
                          <TextField
                            fullWidth
                            size="small"
                            name={`turnoverYear${i}`}
                            value={formData[`turnoverYear${i}`] || ""}
                            onChange={onFieldChange}
                            placeholder=""
                            error={fieldError(`turnoverYear${i}`)}
                            helperText={fieldHelper(`turnoverYear${i}`)}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            fullWidth
                            size="small"
                            type="number"
                            name={`turnoverRevenue${i}`}
                            value={formData[`turnoverRevenue${i}`] ?? ""}
                            onChange={onFieldChange}
                            placeholder=""
                            inputProps={{
                              min: 0,
                            }}
                            error={fieldError(`turnoverRevenue${i}`)}
                            helperText={fieldHelper(`turnoverRevenue${i}`)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </SectionCard>
      )}

      <SectionCard title="NATURE OF BUSINESS">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Product range</TableCell>
                    <TableCell>% of Business Share</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[1, 2, 3, 4, 5].map((i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name={`natureProductRange${i}`}
                          value={formData[`natureProductRange${i}`] || ""}
                          onChange={onFieldChange}
                          error={
                            i === 1 &&
                            touched?.natureProductRange1 &&
                            Boolean(errors?.natureProductRange1)
                          }
                          helperText={
                            i === 1 &&
                            touched?.natureProductRange1 &&
                            errors?.natureProductRange1
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          name={`natureBusinessShare${i}`}
                          value={formData[`natureBusinessShare${i}`] ?? ""}
                          onChange={onFieldChange}
                          placeholder="%"
                          inputProps={{
                            min: 0,
                            max: 100,
                            step: 0.01,
                          }}
                          error={
                            i === 1 &&
                            touched?.natureBusinessShare1 &&
                            Boolean(errors?.natureBusinessShare1)
                          }
                          helperText={
                            i === 1 &&
                            touched?.natureBusinessShare1 &&
                            errors?.natureBusinessShare1
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard title="TOP 5 CUSTOMER">
        <Grid container spacing={2}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Grid item xs={12} sm={6} key={i}>
              <TextField
                fullWidth
                size="small"
                label={`Customer ${i}`}
                name={`top5Customer${i}`}
                value={formData[`top5Customer${i}`] || ""}
                onChange={onFieldChange}
              />
            </Grid>
          ))}
        </Grid>
      </SectionCard>
    </Box>
  );
};

export default Step2BusinessDetails;
